export const VARIANTS = ['regular', 'global'];
